import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, fetchhistory, updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import InvoiceIcon from './InvoiceIcon';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

//

function Invoice() {
    const [data, setData] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedSparepartss, setSelectedSparepartss] = useState("");
    const [formData, setFormData] = useState({});
    const [Remark, setRemark] = useState("");
    const [id, setId] = useState("");
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [openModals, setOpenModal] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchtableData();
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);


    const fetchtableData = async () => {

        fetchData('ScheduleServiceApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Request Details:', error);
            });

    };

    const handleRequest = (id) => {
        console.log(`Request action clicked for item with id ${id}`);
    };
    const [modalOpen, setModalOpen] = useState(false);
    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [allocateModalOpen, setAllocateModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedStaffIds, setSelectedStaffIds] = useState([]);
    const handleRequestAllocation = (id) => {
        setSelectedRequestId(id);
        setAllocateModalOpen(true);
    };

    const [invoiceItems, setInvoiceItems] = useState([]);
    const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
    const [isInvoiceDialogOpen, setIsInvoiceDialogOpen] = useState(false);

    const handleCloseInvoiceDialog = () => {
        setIsInvoiceDialogOpen(false);
    };

    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [selectedSparepart, setSelectedSparepart] = useState('');
    const [sparepartsOptions, setSparepartsOptions] = useState([]);
    const [SpareID, setSpareID] = useState('');

    const fetchSpareparts = async () => {
        try {
            const response = await fetchData('SparePartsApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const firstSparepart = response.response_data[0];
                if (firstSparepart) {
                    setSparepartsOptions(response.response_data);
                    setSpareID(firstSparepart.id);
                    console.log(response.response_data);
                }
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    //Product Type
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState("");

    const fetchProductTypes = async () => {
        try {
            const response = await fetchData('ProductApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setProductTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    useEffect(() => {
        fetchSpareparts();
        fetchProductTypes();
    }, []);

    const handlePrint = () => {

        //window.print();
    };


    const [addedSpareparts, setAddedSpareparts] = useState([]);
    const [itemList, setItemList] = useState([]);

    const addSparepart = () => {
        selectedSpareparts.forEach((selectedItem) => {
            const foundItem = sparepartsOptions.find(item => item.name === selectedItem);
            if (foundItem) {
                const newItem = {
                    ID: foundItem.id,
                    companyID: companyId,
                    Itemname: foundItem.name,
                    SaleRate: foundItem.saleRate,
                };
                setItemList(prevItems => [...prevItems, newItem]);

            }
        });
        // Clear selectedSpareparts after adding items
        setSelectedSpareparts([]);
    };


    // Function to add an invoice item with its quantity, rate, and amount
    const addInvoiceItem = (item, quantity, rate, amount) => {
        setInvoiceItems(prevItems => [...prevItems, { item, quantity, rate, amount }]);
    };

    const removeSparepart = (index) => {
        const updatedSpareparts = [...selectedSpareparts];
        updatedSpareparts.splice(index, 1);
        setSelectedSpareparts(updatedSpareparts);
    };


    const calculateAmount = (sparepart, quantity) => {
        return sparepart.SaleRate * quantity;
    };

    const [selectedSpareparts, setSelectedSpareparts] = useState([]);


    // const [openModal, setOpenModal] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClick = () => {
        setIsModalOpen(true);
    };

    const closeModals = () => {
        setIsModalOpen(false);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        closeModal();
    };


    // Function to handle deleting a row from the grid
    const handleDeleteRow = (index) => {
        const updatedGridData = [...gridData];
        updatedGridData.splice(index, 1);
        setGridData(updatedGridData);
    };

    const [gridData, setGridData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [quantity, setQuantity] = useState('');
    const [rate, setRate] = useState('');
    const [amount, setAmount] = useState('');

    const fetchSpareTypes = async () => {
        try {
            const response = await fetchData('SparePartsApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setSparepartsOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    useEffect(() => {
        fetchProductTypes();
        fetchSpareTypes();
    }, []);


    const handleAddRow = () => {
        if (!selectedProductType || !quantity || !rate || !amount || !salerate) {
            alert('Please fill all fields');
            return;
        }
        const newRow = { product: selectedProductType, selectedSparepartss, quantity, rate, amount, salerate };
        setGridData([...gridData, newRow]);
        setSelectedProduct('');
        setQuantity('');
        setRate('');
        setAmount('');
        setSalerate('');
    };

    const [salerate, setSalerate] = useState('');
    const [productname, setProductname] = useState('');
    const [productCode, setProductCode] = useState('');
    const [gst, setGst] = useState('');

    const [allFieldsFilled, setAllFieldsFilled] = useState(false);
    useEffect(() => {
        const fieldsFilled =
            productname !== '' &&


            setAllFieldsFilled(fieldsFilled);
    }, [productname]);

    const handleProductTypeChange = (e) => {
        const selectedProduct = e.target.value;
        const foundProduct = productTypeOptions.find(product => product.name === selectedProduct);
        if (foundProduct) {
            setSelectedProductType(selectedProduct);
            const updatedItem = {
                ...newItem,
                Name: selectedProduct,
                SaleRate: foundProduct.rate,
                ProductID: foundProduct.id,
                GSTRate: foundProduct.gstRate
            };
            setNewItem(updatedItem);
        }
    };

    const handleSpareTypeChange = (e) => {
        const selectedSpare = e.target.value;
        const foundSpare = sparepartsOptions.find(spare => spare.name === selectedSpare);
        if (foundSpare) {
            setSelectedSpareparts(selectedSpare);
            const updatedItem = {
                ...newItem,
                Name: selectedSpare,
                SaleRate: foundSpare.saleRate,
                SparepartsID: foundSpare.id,
                GSTRate: foundSpare.gstRate
            };
            setNewItem(updatedItem);
        }
    };

    const [newItem, setNewItem] = useState({
        Name: '',
        SaleRate: 0,
        GST: 0,
        quantity: 1
    });

    // implementing the GST Concept
    const [error, setError] = useState(false);
    const AddtoListdata = (e) => {
        e.preventDefault();
        if (!selectedSpareparts) {
            setError(true);
            return;
        }

        const updatedItem = { ...newItem };
        const gstAmount = (newItem.quantity * newItem.SaleRate * newItem.GSTRate) / 100;
        const cgstAmount = gstAmount / 2;
        const sgstAmount = gstAmount / 2;
        updatedItem.Amount = newItem.quantity * newItem.SaleRate + gstAmount;
        updatedItem.CGSTAmount = cgstAmount;
        updatedItem.SGSTAmount = sgstAmount;

        setItemList([...itemList, updatedItem]);
        setNewItem({
            Name: '',
            SaleRate: 0,
            GSTRate: 0,
            quantity: 1,
            ...(selectedOption === 'spare' && { SpareParts: selectedSpareparts })
        });
        setSelectedProductType('');
        setSelectedSpareparts('');
    };


    const [selectedOption, setSelectedOption] = useState('product');
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };

    const handleInvoiceItemSubmit = async () => {
        try {

            const invoiceItems = itemList.map(item => {

                return {
                    EngineerVisitID: selectedInvoiceDetails.requestID,
                    Customer: selectedInvoiceDetails.customer,
                    CustomerID: selectedInvoiceDetails.customerID,
                    CompanyID: companyId,
                    SparepartsID: item.SparepartsID,
                    ProductID: item.ProductID,
                    Quantity: item.quantity,
                    BilledDate: new Date(),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                };
            });

            // Submit the list of invoice items
            postData('InvoicedItemApi', invoiceItems, token)
                .then((response) => {
                    console.log('Invoice Created successfully:', response);

                    setTimeout(() => {

                    }, 3000);
                })
                .catch((error) => {
                    console.error('Invoice Create error:', error);
                });
        } catch (error) {
            console.error('An error occurred while submitting invoice items:', error);
        }
    };


    const [formDatas, setFormDatas] = useState({
        PaymentType: 1 // Default to "Cash" (1)

    });

    const handleToggle = () => {
        setFormDatas(prevState => ({
            ...prevState,
            PaymentType: prevState.PaymentType === 1 ? 2 : 1
        }));
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                <h2 className="text-lg font-semibold mb-4" style={{ color: 'black', marginLeft: '30px', color: 'black', textAlign: 'center', marginTop: '-15px' }}>INVOICE</h2>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', marginLeft: '20px', color: 'black' }}>
                    <div>
                        Name  : <strong>{selectedInvoiceDetails?.customer}</strong><br />
                        Remark: <strong>{selectedInvoiceDetails?.remarks}</strong><br />
                        Date  :<strong> {selectedInvoiceDetails?.dateTime}</strong><br />
                    </div>
                    <div>
                        <Tooltip title="Save">
                            <Button
                                variant="contained"
                                color="success"
                                component={Link}
                                onClick={handleInvoiceItemSubmit}
                                className="linkcolor"
                                style={{ marginLeft: '8px', float: 'right' }}
                                startIcon={<CheckCircleOutlineIcon />}
                            >

                            </Button>
                        </Tooltip>
                    </div>
                </div>

                <div>
                    {error && <p>Please select a spare part before adding.</p>}
                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2" style={{ marginLeft: '10px' }}>
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="spareparts" style={{ fontSize: '16px' }}>
                                Spare
                            </label>
                            <select
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline blackText"
                                value={selectedSpareparts}
                                onChange={handleSpareTypeChange}
                            >
                                <option value="">Spare parts</option>
                                {sparepartsOptions.map((type) => (
                                    <option key={type.id} value={type.name}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="w-1/2 flex">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1" >
                                Qty
                            </label>

                            <div className="w-1/2 flex items-center" style={{ marginTop: '30px', marginLeft: '-20px' }}>

                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={newItem.quantity}
                                    onChange={(e) => setNewItem({ ...newItem, quantity: e.target.value })}
                                />
                                {selectedSpareparts && (
                                    <button
                                        className="ml-2 bg-blue-500 text-white px-3 py-2 rounded"
                                        onClick={AddtoListdata}
                                    >
                                        ADD
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                    <div style={{ marginTop: '-15px' }}>
                        <h6 className='flex justify-end' style={{ color: 'red' }}>Payment mode</h6>

                        <div className="w-1/8 flex justify-end" style={{ marginTop: "10px" }}>
                            <label className="toggleSwitch xSmall">
                                <input
                                    type="checkbox"
                                    id="toggle-switch"
                                    name="PaymentType"
                                    checked={formDatas.PaymentType === 2}
                                    onChange={handleToggle}
                                    style={{ display: "none" }}
                                />
                                <span>
                                    <span>Cash</span>
                                    <span>UPI</span>
                                </span>
                                <a></a>
                            </label>
                        </div>
                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-full mb-4 flex">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Sl.No</th>
                                            <th> Name</th>
                                            <th>Rate</th>
                                            <th>Qty</th>
                                            <th>GST</th>
                                            <th>Amount</th>
                                            {/* <th>DEL</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {itemList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.Name}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item.SaleRate}</td>
                                                <td>{item.GSTRate}</td>
                                                <td>{item.Amount}
                                                    {/* <td></td> */}

                                                    <Tooltip title="Delete">
                                                        <DeleteIcon
                                                            style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                            onClick={() => openConfirmDialog(index)}
                                                        />
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </TableContainer>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete this record?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={() => handleDelete(itemToDeleteIndex)}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </div>
                    </div>
                </div>

            </div>

        </div >
    );
}

export default Invoice;

